import { reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { Tab, Tabs } from 'material-ui/Tabs';
import { connect } from 'react-redux';
import FontIcon from 'material-ui/FontIcon';
import PayerInfo from './../payerModule/information_old';
// import PayerInfo from './../payerModule/information';
import PayerCPTCode from './../payerModule/CptCode';
import PayerActivity from './../payerModule/payerActivities';
import  { base64Decode } from '../../../../actions/utilAction';
import history from '../../../../history';
import { RaisedButton } from 'material-ui';


class PayerHome extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      open: true,
      activeTab: 0,
      activeTabValue: '0',
      payerId: props.match.params.id ? base64Decode(props.match.params.id) : null,
      payerName: null,
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.handlePayerTabChange('0');
      this.setState({ payerId: nextProps.match.params.id ? base64Decode(nextProps.match.params.id) : null });
    }
  };


  setActive(tabValue) {
    if (tabValue === this.state.activeTab) {
      return false;
    }
    this.setState({ activeTab: tabValue });
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };
  
  setPayerName = (payerName) => { 
    this.setState({ payerName: payerName});
  };
  

  handlePayerTabChange = (value) => { //  Change Tab on form Submit.
    this.setState({ activeTabValue: value, activeTab: parseInt(value, 10) });
  };

  handleSave=(formProps) => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  onBackClick = () => {
    history.push('/payers');
  }

  render() {
    var styles = {
      default_tab: {
        height: '50px',
        fontSize: '13px',
      },
      active_tab: {
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.10)',
        height: '48px',
        fontSize: '13px',
      },
    };
    styles.tab = [];
    styles.tab[0] = styles.default_tab;
    styles.tab[1] = styles.default_tab;
    styles.tab[2] = styles.default_tab;
    styles.tab[3] = styles.default_tab;
    styles.tab[4] = styles.default_tab;
    styles.tab[5] = styles.default_tab;
    styles.tab[this.state.activeTab] = styles.active_tab;
    styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
    return (
      <div>
        <h2 className="page_title">{this.state.payerName ? this.state.payerName : 'Add New Payer'}</h2>        
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          <div className="modalwindow mb10">
              <div className="row">
                  <div className="col-sm-2">
                      <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                  </div>
              </div>
          </div>
            <Tabs className="custom_tabs" value={this.state.activeTabValue} onChange={this.handlePayerTabChange}>
              <Tab
                onClick={(e) => this.setActive(0)}
                style={styles.tab[0]}
                value="0"
                className="customtab"
                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                label={<font>Payer Info</font>}>
                <div className="readmin-panel">
                  <div className="panel-body">
                    {this.state.activeTab === 0 ?
                      <PayerInfo payerId={this.state.payerId} handlePayerTabChange={this.handlePayerTabChange} setPayerName = {this.setPayerName} />
                      : null}
                  </div>
                </div>
              </Tab>
              <Tab
                onClick={(e) => this.setActive(1)}
                value="1"
                disabled={!this.state.payerId}
                style={styles.tab[1]}
                className="customtab"
                icon={<FontIcon className="material-icons">assignment</FontIcon>}
                label={<font>Payer Service Codes</font>}>
                <div className="readmin-panel">
                  <div className="panel-body">
                    {this.state.activeTab === 1 ?
                      <PayerCPTCode payerId={this.state.payerId} handlePayerTabChange={this.handlePayerTabChange} />
                      : null}
                  </div>
                </div>
              </Tab>
              <Tab
                onClick={(e) => this.setActive(2)}
                value="2"
                //disabled={this.state.payerActivityDisabled}
                disabled={!this.state.payerId}
                style={styles.tab[2]}
                className="customtab"
                icon={<FontIcon className="material-icons">dvr</FontIcon>}
                label={<font>Payer Activity</font>}>
                <div className="readmin-panel">
                  <div className="panel-body">
                    {this.state.activeTab === 2 ?
                      <PayerActivity payerId={this.state.payerId} handlePayerTabChange={this.handlePayerTabChange} />
                      : null}
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
PayerHome = reduxForm({
  form: 'PayerHomeForm',
})(PayerHome);

export default connect(null)(PayerHome);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/index.js